import { createProjectsWithAIResponseSchema } from "@mg/schemas/src/christo/projects";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getDesigner(
  id: string,
  queries?: (string | number)[],
): Promise<Record<string, any>> {
  const params = queries?.length
    ? "?" +
      new URLSearchParams({
        queries: JSON.stringify(queries),
      })
    : "";
  const json = await smartFetch(
    `${API_URL}/private/my-network/profiles/${id}${params}`,
    {
      method: "GET",
    },
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return json as Record<string, any>;
}

export async function updateTags(payload: {
  tags: string[];
  portfolioId: string;
}) {
  const { portfolioId, tags } = payload;

  const json = await smartFetch(
    `${API_URL}/private/my-network/profiles/${portfolioId}/tags`,
    {
      method: "PUT",
      body: JSON.stringify({ tags }),
    },
  );

  return json;
}

export function getTags() {
  const json = smartFetch(`${API_URL}/private/my-network/tags`, {
    method: "GET",
  });

  return json;
}

export async function aiParseImage(key: string) {
  // dev/users/{userId}/{filename}
  const json = await smartFetch(`${API_URL}/private/projects/ai`, {
    method: "POST",
    body: JSON.stringify([
      {
        assets: [
          {
            type: "image",
            source: key,
          },
        ],
      },
    ]),
  });

  const parsedData = createProjectsWithAIResponseSchema.parse(json);
  return parsedData;
}

export async function shareProfile({
  objectId,
  payload,
}: {
  objectId: string;
  payload: Record<string, unknown>;
}) {
  await smartFetch(`${API_URL}/private/my-network/profiles/${objectId}/share`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return undefined;
}
